module.exports = __webpack_public_path__ + "img/mxn.9de36972.png";